/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';
import {Help, HelpOutline} from '@mui/icons-material';

export const IconBox = styled(Box)(() => ({
  width: 28,
  height: 28,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledIcon = styled(HelpOutline)(({theme}) => ({
  fontSize: 18,
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
}));

export const StyledFilledIcon = styled(Help)(({theme}) => ({
  fontSize: 18,
  color: theme.palette.semantic_dark?.surface.onSurface,
}));
